module.exports = __webpack_public_path__ + "static/media/MERMELADA DE FRESA  270 sin octagono.f4155aad.png";